const studentRoutes = [
  { path: '/studentHome', name: 'Predavanja', icon: 'pe-7s-micro' },
  { path: '/studentStat', name: 'Pregled', icon: 'pe-7s-users' },
  { redirect: true, path: '/', to: '/login', name: 'Login' }
];

export default studentRoutes;
